<template>
  <inventoryProvidersForm :typeEndPoint="'inventoryProvidersForm'" :dataParams="{}"/>
</template>
<script>
import inventoryProvidersForm from '@/components/modules/inventory/providers/form'
export default {
  name: 'inventoryProvidersCreate',
  components: {
    inventoryProvidersForm
  }
}
</script>



// WEBPACK FOOTER //
// src/views/inventory/providers/create.vue